/**
 * Runtime configuration — loaded from /config.json BEFORE React renders.
 *
 * A single build artifact works in every environment: ops swap config.json,
 * never rebuild. No import.meta.env for environment-specific values.
 */

export interface AppConfig {
  apiBaseUrl: string;
  wsUrl: string;
  keycloak: {
    authority: string;
    clientId: string;
  };
  /** Optional environment label surfaced in the shell footer (e.g. "prod", "staging"). */
  env?: string;
}

let config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (config) return config;
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to load /config.json: ${response.status}`);
  }
  config = (await response.json()) as AppConfig;
  return config;
}

export function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Config not loaded — loadConfig() must run before render');
  }
  return config;
}
